import client from "@/lib/api";

const KEY = "sc_attrib";
const MAX_AGE_MS = 30 * 24 * 60 * 60 * 1000; // 30-day first-touch window

// Read src/via/ref off the current URL and store a first-touch attribution record.
// Call on app mount — covers /i/{ref} landings and any /app/... deep link.
export function captureAttribution() {
  try {
    const p = new URLSearchParams(window.location.search);
    const src = p.get("src") || "";
    const via = p.get("via") || "";
    const ref = p.get("ref") || "";
    if (!src && !via && !ref) return;
    const existing = JSON.parse(localStorage.getItem(KEY) || "null");
    if (existing && Date.now() - (existing.ts || 0) < MAX_AGE_MS) return; // keep first touch
    localStorage.setItem(KEY, JSON.stringify({ src, via, ref, ts: Date.now() }));
  } catch { /* ignore */ }
}

// Fire once right after a successful signup to credit the referring share/platform.
export async function flushAttribution() {
  try {
    const a = JSON.parse(localStorage.getItem(KEY) || "null");
    if (!a) return;
    await client.post("/share/attribution", { src: a.src, via: a.via, ref: a.ref });
    localStorage.removeItem(KEY);
  } catch { /* non-blocking */ }
}
